import { Trans } from '@lingui/react/macro';
import { NoddiLink } from 'noddi-ui-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { useHasSupportChat } from '../../supportWidget/useHasSupportChat';

type Props = {
  customText?: string;
  className?: string;
};

export const ContactUs = ({ customText, className }: Props) => {
  const { brandEmail } = useCurrentBrand();
  // Not every brand has a support chat; never point customers to one that is not there.
  const hasSupportChat = useHasSupportChat();

  // do not remove the spaces {' '}, they are necessary for correct spacing in the rendered text
  return (
    <span className={className}>
      {hasSupportChat ? (
        <Trans>Feel free to reach out to us in the chat or at</Trans>
      ) : (
        <Trans>Feel free to reach out to us at</Trans>
      )}{' '}
      <NoddiLink size='small' className='inline-flex p-0' variant='link' to={`mailto:${brandEmail}`}>
        {brandEmail}
      </NoddiLink>{' '}
      {customText ?? <Trans>if you have any questions</Trans>}
    </span>
  );
};
